import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import type { ArticleStatistics } from '@/@types/graphql-types';

import { useI18n } from '@/helpers/composables/useI18n';
import { formatRuntime } from '@/helpers/title-helper';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListArticleStats',
  props: {
    stats: null
  },
  setup(__props: any) {

const props = __props as {
	stats: ArticleStatistics;
};



const languageStore = useLanguageStore();

const { t } = useI18n();

const totalCost = computed(() => {
	if (!props.stats.totalCost?.amount) return;

	const currency =
		props.stats.totalCost?.currency !== '' ? props.stats.totalCost?.currency : languageStore.localeObject.currency;

	return new Intl.NumberFormat(`${languageStore.country}-${languageStore.language}`, {
		style: 'currency',
		currency,
	}).format(props.stats.totalCost?.amount ?? 0);
});

const totalWatchTime = computed(() => {
	if (!props.stats.estimatedTotalWatchTime) return;

	const { translationKey, minutes, hours } = formatRuntime(props.stats.estimatedTotalWatchTime);
	return t(translationKey, { minutes, hours }) as string;
});

const keywords = computed(() => props.stats.keywords?.join(', ') ?? '');

return { __sfc: true,props, languageStore, t, totalCost, totalWatchTime, keywords }
}

})